import type { LogsEvent } from '@datadog/browser-logs';

import { redactSensitiveUrl } from './redactSensitiveUrl';

// Drops the query string and fragment, which can carry tokens, UTM or other
// visitor data.
const stripUrlParams = (url: string) =>
  redactSensitiveUrl(url).replace(/[?#].*$/, '');

/**
 * Datadog Logs runs before consent as error reporting, like Sentry (counsel,
 * 2026-10-29), so no URL it sends may carry query params. Network error
 * messages embed the request URL, so those are stripped too, and their stack
 * holds the response body, which can echo the operation back.
 *
 * `beforeSend` edits the event in place; returning `true` keeps it. Must never
 * throw, or Datadog drops logging entirely.
 */
/* eslint-disable no-param-reassign */
export function scrubDatadogLog(event: LogsEvent): boolean {
  try {
    event.view.url = stripUrlParams(event.view.url);
    if (event.view.referrer)
      event.view.referrer = stripUrlParams(event.view.referrer);
    if (event.http) event.http.url = stripUrlParams(event.http.url);
    event.message = event.message.replace(
      /(https?:\/\/[^\s?#]+)[?#]\S*/g,
      '$1',
    );
    if (event.origin === 'network' && event.error) delete event.error.stack;
  } catch {
    // never break logging on a malformed event
  }
  return true;
}
/* eslint-enable no-param-reassign */
